// extracted by css-extract-rspack-plugin
export default {"root":"z_YD4Vt_LAK27SWv","label":"x47r1hfBH4DZcudQ"};